/** Umbrella experiment that gates whether the editor VSM engine is available. */
export const VSM_EDITOR_EXPERIMENT = 'specs.thunderbolt.vsm_editor' as const

/** Shared experiment that converts every registered editor feature from Carmi to VSM. */
export const VSM_EDITOR_CONFIGS_EXPERIMENT = 'specs.thunderbolt.vsmEditorConfigs' as const

/**
 * Editor VSM platform surface (ADR-0007): the `*WixCodeSdk` editor configs — the platform worker
 * bootstrap's inputs, read from Carmi's `siteFeaturesConfigs` aggregate — and, with TB-15447, the platform
 * module itself convert under this spec instead of `VSM_EDITOR_CONFIGS_EXPERIMENT`, so the worker's inputs
 * flip together with their producer. Must stay closed until TB-15447 lands.
 */
export const VSM_EDITOR_PLATFORM_EXPERIMENT = 'specs.thunderbolt.vsmEditorPlatform' as const

/**
 * Not a VSM conversion spec — it gates the `platform-ds` Carmi-free refactor (#50085) — but it lives
 * here because it is a **precondition of the one above**. `createBootstrapData` keeps reading Carmi's
 * `siteFeaturesConfigs` aggregate while this is closed, and the `*WixCodeSdk` site configs leave that
 * aggregate as soon as `VSM_EDITOR_PLATFORM_EXPERIMENT` opens, so the two open in order or the SDK
 * factories are handed nothing: this one first, the platform spec second. Anything that opens the
 * platform spec — a rollout, or a sled lane — has to open this one alongside it.
 */
export const PLATFORM_DS_CARMI_FREE_EXPERIMENT = 'platformDsCarmiFree' as const
